module.exports = __webpack_public_path__ + "img/bs_banner.7da44b4a.jpg";